import { Big } from 'big.js'
import {
  type NumericFormatProps,
  numericFormatter,
  removeNumericFormat,
} from 'react-number-format'

import type { RawTextInputProps } from '../textInput/RawTextInput'

export const createNumberInputKeyDownHandler =
  (
    options: NumericFormatProps,
    onKeyDown: RawTextInputProps['onKeyDown'],
  ): RawTextInputProps['onKeyDown'] =>
  (event) => {
    onKeyDown?.(event)

    const input = event.currentTarget
    if (
      event.defaultPrevented ||
      input.disabled ||
      input.readOnly ||
      (event.key !== 'ArrowUp' && event.key !== 'ArrowDown')
    ) {
      return
    }

    event.preventDefault()
    const currentValue = removeNumericFormat(
      input.value,
      {
        from: { start: 0, end: 0 },
        to: { start: 0, end: input.value.length },
        lastValue: '',
      },
      options,
    )
    const parsedValue = Number(currentValue)
    const nextValue = new Big(Number.isFinite(parsedValue) ? parsedValue : 0)
      .plus(event.key === 'ArrowUp' ? 1 : -1)
      .toFixed()
    const setValue = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value',
    )!.set!
    setValue.call(input, numericFormatter(nextValue, options))
    input.dispatchEvent(new Event('input', { bubbles: true }))
  }
